import TextField from "./TextField";
import ImageField from "./ImageField";
import { Row, Col, message, Typography } from "antd";
import { updateCompanyDetails } from "api/customApis";

const { Title } = Typography;

export default function CompanyDetails({ data, updateData, fetchData }) {
	const updateText = (d, callback, label) => {
		updateCompanyDetails(data.id, { [d.fieldId]: d.fieldValue })
			.then((res) => {
				if (callback) {
					callback(d.fieldValue);
				}
				if (label) {
					message.success(`${label} updated successfully`);
				}
				fetchData();
			})
			.catch((err) => {
				console.log(err);
				message.error(`Failed to update ${d.fieldId}`);
			});
	};
	return (
		<div>
			<Row>
				<Title level={5} type="secondary">
					COMPANY DETAILS
				</Title>
			</Row>
			<Row
				style={{
					paddingRight: "1rem",
					width: window.innerWidth > 900 ? "70%" : "100%",
					paddingBottom: "1.5rem",
					borderBottom: "1px solid #E6E7E7",
					marginTop: "1.5em",
				}}
			>
				<Col span={7}>
					<Row>
						<Title level={5}>Logo</Title>
					</Row>
					<Row>
						<ImageField
							label="Logo"
							src={data.logo}
							fieldId="logo"
							updateText={updateText}
							width={300}
							height={300}
						/>
					</Row>
				</Col>
				<Col span={16} offset={1}>
					<Row>
						<Title level={5}>Cover image</Title>
					</Row>

					<ImageField
						label="Logo"
						src={data.banner}
						fieldId="banner"
						updateText={updateText}
						width={1200}
						height={300}
						fetchData={fetchData}
					/>
				</Col>
			</Row>

			<TextField
				updateText={updateText}
				label="Company Name"
				value={data.name}
				editable
				fieldId="name"
			/>
		</div>
	);
}
